import { MotivationalQuote, Badge, PillarInfo } from '@/types';

export const MOTIVATIONAL_QUOTES: MotivationalQuote[] = [
  {
    id: '1',
    text: 'A jornada de mil milhas começa com um único passo.',
    author: 'Lao Tzu',
    category: 'geral',
  },
  {
    id: '2',
    text: 'O sucesso é a soma de pequenos esforços repetidos dia após dia.',
    author: 'Robert Collier',
    category: 'geral',
  },
  {
    id: '3',
    text: 'Você não precisa ser ótimo para começar, mas precisa começar para ser ótimo.',
    author: 'Zig Ziglar',
    category: 'interior',
  },
  {
    id: '4',
    text: 'O único lugar onde sucesso vem antes de trabalho é no dicionário.',
    author: 'Vidal Sassoon',
    category: 'profissional',
  },
  {
    id: '5',
    text: 'Sua saúde é um investimento, não uma despesa.',
    author: 'Anônimo',
    category: 'saudavel',
  },
  {
    id: '6',
    text: 'A paz vem de dentro. Não a busque fora.',
    author: 'Buda',
    category: 'espiritual',
  },
  {
    id: '7',
    text: 'Sozinhos podemos fazer tão pouco; juntos podemos fazer tanto.',
    author: 'Helen Keller',
    category: 'social',
  },
  {
    id: '8',
    text: 'O amor é a única força capaz de transformar um inimigo em amigo.',
    author: 'Martin Luther King Jr.',
    category: 'sentimental',
  },
  {
    id: '9',
    text: 'Não conte os dias, faça os dias contarem.',
    author: 'Muhammad Ali',
    category: 'geral',
  },
  {
    id: '10',
    text: 'A vida é 10% o que acontece com você e 90% como você reage a isso.',
    author: 'Charles R. Swindoll',
    category: 'interior',
  },
];

export const BADGES: Badge[] = [
  {
    id: 'badge-onboarding',
    name: 'Primeiro Passo',
    description: 'Completou o onboarding',
    icon: 'Flag',
    criteria: 'onboarding',
    color: 'hsl(213 94% 68%)',
  },
  {
    id: 'badge-wheel',
    name: 'Autoconhecimento',
    description: 'Completou a Roda da Vida',
    icon: 'CircleDot',
    criteria: 'primeiraRoda',
    color: 'hsl(258 90% 66%)',
  },
  {
    id: 'badge-streak7',
    name: 'Consistência',
    description: '7 dias de sequência',
    icon: 'Flame',
    criteria: 'streak7',
    color: 'hsl(38 92% 50%)',
  },
  {
    id: 'badge-streak21',
    name: 'Hábito Formado',
    description: '21 dias de sequência',
    icon: 'Zap',
    criteria: 'streak21',
    color: 'hsl(158 64% 52%)',
  },
  {
    id: 'badge-streak66',
    name: 'Estilo de Vida',
    description: '66 dias de sequência',
    icon: 'Trophy',
    criteria: 'streak66',
    color: 'hsl(38 92% 50%)',
  },
  {
    id: 'badge-streak90',
    name: 'Mestre da Transformação',
    description: '90 dias de sequência - Desafio completo!',
    icon: 'Crown',
    criteria: 'streak90',
    color: 'hsl(48 100% 50%)',
  },
  {
    id: 'badge-goal1',
    name: 'Planejador',
    description: 'Criou sua primeira meta SMART',
    icon: 'Target',
    criteria: 'primeiraMeta',
    color: 'hsl(217 91% 60%)',
  },
  {
    id: 'badge-habit1',
    name: 'Construtor de Hábitos',
    description: 'Criou seu primeiro hábito',
    icon: 'Repeat',
    criteria: 'primeiroHabito',
    color: 'hsl(160 84% 39%)',
  },
  {
    id: 'badge-hydration',
    name: 'Hidratado',
    description: 'Bebeu 2L de água em um dia',
    icon: 'Droplet',
    criteria: 'agua2L',
    color: 'hsl(200 80% 50%)',
  },
];

export const PILLAR_INFO: Record<string, PillarInfo> = {
  interior: {
    slug: 'interior',
    name: 'Pessoal / Interior',
    icon: 'heart',
    description: 'Desenvolvimento pessoal, autoconhecimento, mindfulness',
    color: 'hsl(258 90% 66%)',
    lightColor: 'hsl(258 90% 96%)',
  },
  profissional: {
    slug: 'profissional',
    name: 'Profissional',
    icon: 'briefcase',
    description: 'Carreira, habilidades, networking, finanças',
    color: 'hsl(217 91% 60%)',
    lightColor: 'hsl(217 91% 96%)',
  },
  espiritual: {
    slug: 'espiritual',
    name: 'Espiritual',
    icon: 'sparkles',
    description: 'Conexão espiritual, propósito, meditação',
    color: 'hsl(280 85% 70%)',
    lightColor: 'hsl(280 85% 96%)',
  },
  saudavel: {
    slug: 'saudavel',
    name: 'Saudável',
    icon: 'activity',
    description: 'Saúde física, exercícios, alimentação',
    color: 'hsl(160 84% 39%)',
    lightColor: 'hsl(160 84% 96%)',
  },
  social: {
    slug: 'social',
    name: 'Social',
    icon: 'users',
    description: 'Relacionamentos, amizades, família',
    color: 'hsl(340 82% 62%)',
    lightColor: 'hsl(340 82% 96%)',
  },
  sentimental: {
    slug: 'sentimental',
    name: 'Sentimental',
    icon: 'heart-handshake',
    description: 'Vida amorosa, intimidade, parceria',
    color: 'hsl(348 83% 67%)',
    lightColor: 'hsl(348 83% 96%)',
  },
};

export function getRandomQuote(category?: string): MotivationalQuote {
  const filtered = category 
    ? MOTIVATIONAL_QUOTES.filter(q => q.category === category || q.category === 'geral')
    : MOTIVATIONAL_QUOTES;
  
  return filtered[Math.floor(Math.random() * filtered.length)];
}

export function getPillarInfo(slug: string): PillarInfo {
  return PILLAR_INFO[slug] || PILLAR_INFO.interior;
}
